import { useEffect, useState } from "react";
import { api, fmtMoney } from "@/lib/api";
import { Trash2, Plus } from "lucide-react";
import { toast } from "sonner";

export default function AdminDiscounts() {
  const [codes, setCodes] = useState([]);
  const [form, setForm] = useState({ code: "", discount_type: "percent", value: 10, min_subtotal: 0, active: true });

  const load = () => api.get("/discounts/admin").then((r) => setCodes(r.data.items));
  useEffect(() => { load(); }, []);

  const create = async (e) => {
    e.preventDefault();
    try {
      await api.post("/discounts/admin", {
        ...form,
        code: form.code.trim().toUpperCase(),
        value: parseFloat(form.value),
        min_subtotal: parseFloat(form.min_subtotal),
      });
      toast.success("Code created");
      setForm({ code: "", discount_type: "percent", value: 10, min_subtotal: 0, active: true });
      load();
    } catch (err) {
      toast.error(err?.response?.data?.detail || "Create failed");
    }
  };

  const remove = async (id) => {
    if (!window.confirm("Delete code?")) return;
    await api.delete(`/discounts/admin/${id}`);
    load();
  };

  return (
    <div data-testid="admin-discounts">
      <div className="ipv-eyebrow text-[#0A1C40]">Marketing</div>
      <h1 className="font-display font-black text-3xl tracking-tighter mt-2">Discount codes</h1>

      <form onSubmit={create} className="bg-white border border-gray-200 p-5 mt-8 grid md:grid-cols-5 gap-3 items-end">
        <div>
          <label className="ipv-eyebrow block mb-1.5">Code</label>
          <input className="input-base" placeholder="WELCOME10" required value={form.code} onChange={(e) => setForm({ ...form, code: e.target.value })} data-testid="dc-code" />
        </div>
        <div>
          <label className="ipv-eyebrow block mb-1.5">Type</label>
          <select className="input-base" value={form.discount_type} onChange={(e) => setForm({ ...form, discount_type: e.target.value })} data-testid="dc-type">
            <option value="percent">Percent (%)</option>
            <option value="flat">Flat ($)</option>
          </select>
        </div>
        <div>
          <label className="ipv-eyebrow block mb-1.5">Value</label>
          <input type="number" step="0.01" className="input-base" value={form.value} onChange={(e) => setForm({ ...form, value: e.target.value })} data-testid="dc-value" />
        </div>
        <div>
          <label className="ipv-eyebrow block mb-1.5">Min subtotal</label>
          <input type="number" step="0.01" className="input-base" value={form.min_subtotal} onChange={(e) => setForm({ ...form, min_subtotal: e.target.value })} data-testid="dc-min" />
        </div>
        <button className="btn-primary inline-flex items-center justify-center gap-2" data-testid="dc-create-btn">
          <Plus className="w-4 h-4" /> Create
        </button>
      </form>

      <div className="bg-white border border-gray-200 mt-6">
        <table className="w-full text-sm">
          <thead className="bg-[#FAFAFA] border-b border-gray-200 ipv-eyebrow text-left">
            <tr>
              <th className="p-3">Code</th>
              <th className="p-3">Type</th>
              <th className="p-3 text-right">Value</th>
              <th className="p-3 text-right">Min subtotal</th>
              <th className="p-3">Active</th>
              <th className="p-3"></th>
            </tr>
          </thead>
          <tbody className="divide-y divide-gray-100">
            {codes.length === 0 && (
              <tr><td colSpan={6} className="p-8 text-center text-gray-500">No discount codes yet.</td></tr>
            )}
            {codes.map((c) => (
              <tr key={c.id} data-testid={`dc-row-${c.code}`}>
                <td className="p-3 font-bold font-mono">{c.code}</td>
                <td className="p-3 capitalize">{c.discount_type}</td>
                <td className="p-3 text-right font-bold">
                  {c.discount_type === "percent" ? `${c.value}%` : fmtMoney(c.value)}
                </td>
                <td className="p-3 text-right">{fmtMoney(c.min_subtotal)}</td>
                <td className="p-3">
                  {c.active ? <span className="text-green-700">●</span> : <span className="text-gray-400">○</span>}
                </td>
                <td className="p-3 text-right">
                  <button onClick={() => remove(c.id)} className="p-2 hover:bg-red-50 text-[#DC2626]" data-testid={`dc-delete-${c.code}`}>
                    <Trash2 className="w-3.5 h-3.5" />
                  </button>
                </td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>
    </div>
  );
}
